import { render, staticRenderFns } from "./CancelledForm.vue?vue&type=template&id=3b432aff&"
import script from "./CancelledForm.vue?vue&type=script&lang=js&"
export * from "./CancelledForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports